import {Component, EventEmitter, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TaskServiceService} from '../../../services/task-service.service';
import {TaskLifeModel, TaskModel} from '../../../models/task.model';
import {CrmService} from '../../../services/api/crm.service';
import {AlertService} from '../../../services/notify/alert.service';
import {BoardGroupModel, BoardTableModel} from '../../../models/tasktable.model';
import {PaginationModel} from '../../../models/file-table.model';

@Component({
    selector: 'app-tasks-all',
    templateUrl: './tasks-all.component.html',
    styleUrls: ['./tasks-all.component.scss'],
})
export class TasksAllComponent implements OnInit {
    public emitReloading: EventEmitter<TaskModel> = new EventEmitter<TaskModel>();
    public emitSaveSettings: EventEmitter<any> = new EventEmitter<any>();
    public board: string;
    public alias: string;
    public boards: BoardTableModel[];

    boardGroups: BoardGroupModel[];

    viewType: string;
    range: any;

    filter: string;

    boardLife: TaskLifeModel[] = [];
    pagination: PaginationModel = {
        limit: 20,
        current_page: 1,
        pages: 1,
    };

    constructor(
        private route: ActivatedRoute,
        private taskService: TaskServiceService,
        private router: Router,
        private crmService: CrmService,
        private alertService: AlertService,
    ) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(res => {
            this.alias = res.alias;
        });

        this.board = document.location.pathname.split('/').reverse()[this.alias ? 1 : 0];

        if (localStorage.getItem('view_type_storage') && JSON.parse(localStorage.getItem('view_type_storage'))[this.alias]) {
            const viewTypeStorage = JSON.parse(localStorage.getItem('view_type_storage'));
            this.viewType = viewTypeStorage[this.alias];
        } else {
            this.viewType = this.board === 'all' ? 'column' : 'table';
        }

        if (this.viewType === 'logs') {
            this.getLogs(1);
        }

        if (!this.boards && !this.alias && this.board === 'all') {
            this.taskService.getAllBoards(false).then(res => {
                this.boards = res.boards;
                this.boardGroups = res.groups;
            });
        }

        if (window.location.hash) {
            void this.router.navigate([
                'account/tasks/all',
                window.location.hash.split('-')[0].substring(1),
                window.location.hash.substring(1),
            ]);
        }
    }

    getLogs(page: number): void {
        this.pagination.current_page = page;
        this.boardLife = [];
        this.crmService.getBoardLife(this.alias, this.pagination).subscribe({
            next: res => {
                this.boardLife = res.data;
                this.pagination.pages = res.page_count;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            },
        });
    }

    onCreateTask(task: TaskModel): void {
        window.location.hash = task.task_alias;
        this.emitReloading.emit(task);
    }

    reload(): void {
        this.taskService.getAllBoards(true).then(res => {
            this.boards = res.boards;
            this.boardGroups = res.groups;
        });
    }

    reloadAfterDelete(event: boolean): void {
        if (event === false) {
            this.taskService.getAllBoards(true).then(res => {
                this.boards = res.boards;
                this.boardGroups = res.groups;
            });
        }
    }

    changeViewType(event: string | { type: string, logs: { data: TaskLifeModel[]; page_count: number } }): void {
        if (typeof event === 'string') {
            this.viewType = event;
            if (localStorage.getItem('view_type_storage')) {
                const preChange = JSON.parse(localStorage.getItem('view_type_storage'));
                preChange[this.alias] = event;
                localStorage.setItem('view_type_storage', JSON.stringify(preChange));
            } else {
                const data = {[this.alias]: event};
                localStorage.setItem('view_type_storage', JSON.stringify(data));
            }

        } else {
            this.viewType = event.type;

            if (localStorage.getItem('view_type_storage')) {
                const preChange = JSON.parse(localStorage.getItem('view_type_storage'));
                preChange[this.alias] = event.type;
                localStorage.setItem('view_type_storage', JSON.stringify(preChange));
            } else {
                const data = {[this.alias]: event.type};
                localStorage.setItem('view_type_storage', JSON.stringify(data));
            }
            this.pagination.pages = event.logs.page_count;
            this.boardLife = event.logs.data;
        }
    }
}
